module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/FM-0218671a1078d17a358ac62b7cfbcac7.png";